import { translate } from "../../../common/providers";

/**
 * Returns the custom label for the apply button based on result count
 * @param {number|null} results - Number of results
 * @returns {string} Translated label
 */
export const getCustomLabelApply = (results) => {
	if (results !== null && results <= 1) {
		return translate("common:component.filter.apply", { results });
	}
	if (results > 1) {
		return translate("common:component.filters.apply", { results });
	}
	return translate("common:btn.apply");
};
